<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#FFFFFF;}
	.st1{fill:#DC648F;}
	.st2{fill:#E14C81;}
	.st3{fill:#D05097;}
	.st4{fill:#E394AC;}
	.st5{fill:#944073;}
	.st6{fill:#E46870;}
	.st7{fill:#E2ACCF;}
	.st8{fill:#CF555A;}
	.st9{fill:#E4AFCF;}
	.st10{fill:#8262A7;}
	.st11{fill:#E64773;}
	.st12{fill:#E8B3D3;}
	.st13{fill:#E83D5E;}
	.st14{fill:#EF7752;}
	.st15{fill:#C14B96;}
	.st16{fill:#EDB9BE;}
	.st17{fill:#86559E;}
	.st18{fill:#B57AB3;}
	.st19{fill:#D74E8F;}
	.st20{fill:#E77270;}
	.st21{fill:#F8C18F;}
	.st22{fill:#ED6B83;}
	.st23{fill:#EE885B;}
	.st24{fill:#704F9B;}
	.st25{fill:#806FB0;}
	.st26{fill:#B599C8;}
</style>
<path class="st0" d="M15,0h10c8.3,0,15,6.7,15,15v10c0,8.3-6.7,15-15,15H15C6.7,40,0,33.3,0,25V15C0,6.7,6.7,0,15,0z"/>
<g id="logo_theia">
	<path class="st1" d="M20,27.2c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S19.2,27.2,20,27.2z"/>
	<path class="st2" d="M20,15.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S19.2,15.8,20,15.8z"/>
	<path class="st3" d="M14.3,21.5c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S13.4,21.5,14.3,21.5z"/>
	<path class="st4" d="M25.7,21.5c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S24.9,21.5,25.7,21.5z"/>
	<path class="st5" d="M16,17.5c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5C14.4,16.8,15.1,17.5,16,17.5z"/>
	<path class="st6" d="M24,25.6c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S23.2,25.6,24,25.6z"/>
	<path class="st7" d="M16,25.6c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5C14.4,24.9,15.1,25.6,16,25.6z"/>
	<path class="st8" d="M24,17.5c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S23.2,17.5,24,17.5z"/>
	<path class="st9" d="M22.6,11.6c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S21.8,11.6,22.6,11.6z"/>
	<path class="st10" d="M17.4,31.4c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S16.5,31.4,17.4,31.4z"/>
	<path class="st11" d="M17.3,11.6c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S16.5,11.6,17.3,11.6z"/>
	<path class="st12" d="M22.7,31.4c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C21.2,30.7,21.9,31.4,22.7,31.4z"/>
	<path class="st13" d="M12.7,14.3c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S11.9,14.3,12.7,14.3z"/>
	<path class="st5" d="M27.3,28.7c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C25.8,28.1,26.4,28.7,27.3,28.7z"/>
	<path class="st8" d="M10.1,18.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C8.6,18.2,9.3,18.9,10.1,18.9z"/>
	<path class="st14" d="M29.9,24.1c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C28.4,23.5,29.1,24.1,29.9,24.1z"/>
	<path class="st15" d="M10.1,24.2c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S9.3,24.2,10.1,24.2z"/>
	<path class="st16" d="M29.9,18.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C28.4,18.1,29.1,18.8,29.9,18.8z"/>
	<path class="st17" d="M12.8,28.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C11.3,28.1,11.9,28.8,12.8,28.8z"/>
	<path class="st18" d="M27.2,14.2c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S26.4,14.2,27.2,14.2z"/>
	<path class="st19" d="M20,6.7c0.8,0,1.5-0.7,1.5-1.5S20.8,3.7,20,3.7s-1.5,0.7-1.5,1.5C18.5,6.1,19.2,6.7,20,6.7z"/>
	<path class="st20" d="M20,36.3c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S19.2,36.3,20,36.3z"/>
	<path class="st8" d="M12.6,8.7c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S11.8,8.7,12.6,8.7z"/>
	<path class="st21" d="M27.4,34.3c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S26.6,34.3,27.4,34.3z"/>
	<path class="st22" d="M7.2,14.1c0.8,0,1.5-0.7,1.5-1.5S8,11.1,7.2,11.1s-1.5,0.7-1.5,1.5C5.7,13.5,6.4,14.1,7.2,14.1z"/>
	<path class="st23" d="M32.8,28.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C31.3,28.2,32,28.9,32.8,28.9z"/>
	<path class="st24" d="M5.2,21.5c0.8,0,1.5-0.7,1.5-1.5S6,18.5,5.2,18.5S3.7,19.2,3.7,20S4.4,21.5,5.2,21.5z"/>
	<path class="st8" d="M34.8,21.5c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S33.9,21.5,34.8,21.5z"/>
	<path class="st8" d="M7.2,28.9c0.8,0,1.5-0.7,1.5-1.5S8,25.9,7.2,25.9s-1.5,0.7-1.5,1.5C5.7,28.2,6.4,28.9,7.2,28.9z"/>
	<path class="st25" d="M32.8,14.1c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C31.3,13.4,32,14.1,32.8,14.1z"/>
	<path class="st26" d="M12.6,34.3c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S11.8,34.3,12.6,34.3z"/>
	<path class="st5" d="M27.4,8.7c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S26.5,8.7,27.4,8.7z"/>
</g>
</svg>
